var React = require('react');

function ProductsIcon27Inline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Intersection_1","data-name":"Intersection 1","d":"M-4007,15092.269a15.265,15.265,0,0,1,15.269-15.269,15.273,15.273,0,0,1,15.272,15.269,15.277,15.277,0,0,1-15.272,15.272A15.276,15.276,0,0,1-4007,15092.269Zm3,.012a12.283,12.283,0,0,0,12.268,12.269v-.008a12.294,12.294,0,0,0,12.272-12.272,12.286,12.286,0,0,0-12.272-12.269A12.293,12.293,0,0,0-4004,15092.28Zm10.858,6.962,6.552-13.284h3.088l-6.541,13.284Zm-3.18,0-3.64-8.161h3.18l3.64,8.161Z","transform":"translate(4007 -15077)","fill":"#1a1b21"}));
}

ProductsIcon27Inline.defaultProps = {"width":"30.541","height":"30.541","viewBox":"0 0 30.541 30.541"};

module.exports = ProductsIcon27Inline;

ProductsIcon27Inline.default = ProductsIcon27Inline;
